import { render, staticRenderFns } from "./BackgroundSlider.vue?vue&type=template&id=5c538fe0"
import script from "./BackgroundSlider.vue?vue&type=script&lang=js"
export * from "./BackgroundSlider.vue?vue&type=script&lang=js"
import style0 from "./BackgroundSlider.vue?vue&type=style&index=0&id=5c538fe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports